var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81579 10.6115C6.44455 10.4223 6.03127 10.3243 5.61099 10.3243C2.3328 10.5554 2.3328 15.3256 5.61099 15.5568H13.3792C14.3248 15.5638 15.2354 15.2135 15.9289 14.5761C18.2334 12.5658 17.0006 8.52405 13.9676 8.1388C12.8748 1.57541 3.39751 4.06908 5.64601 10.3243",
    fill: "url(#paint0_linear_1389_9515)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_9515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1348,
    y: 10.8816,
    width: 5.86439,
    height: 5.86439,
    rx: 2.93219,
    fill: "url(#paint1_linear_1389_9515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1543 12.4233V13.4662H14.1971",
    stroke: "white",
    strokeWidth: 0.347611,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9784 15.2042V14.1614H15.9355",
    stroke: "white",
    strokeWidth: 0.347611,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5418 13.2924C16.4536 13.0433 16.3038 12.8205 16.1063 12.645C15.9088 12.4695 15.67 12.3468 15.4123 12.2885C15.1546 12.2302 14.8863 12.2381 14.6325 12.3115C14.3786 12.385 14.1476 12.5215 13.9608 12.7084L13.1543 13.4662M16.978 14.1614L16.1716 14.9192C15.9848 15.1061 15.7537 15.2426 15.4998 15.316C15.246 15.3894 14.9777 15.3974 14.72 15.339C14.4623 15.2807 14.2235 15.1581 14.026 14.9825C13.8285 14.807 13.6787 14.5843 13.5905 14.3352",
    stroke: "white",
    strokeWidth: 0.347611,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9515",
    x1: 9.52434,
    y1: 4.26825,
    x2: 8.57271,
    y2: 18.2379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FF8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9515",
    x1: 15.067,
    y1: 10.8816,
    x2: 15.067,
    y2: 16.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_9515"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1348,
    y: 10.8816,
    width: 5.86439,
    height: 5.86439,
    rx: 2.93219,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon5);
export default __webpack_public_path__ + "static/media/camera_card_icon5.6b66285a6077f784f8513dcfd72def61.svg";
export { ForwardRef as ReactComponent };